<template>
  <div class="container-fluid autenticacao">
    <div class="card autenticacao-card autenticacao-card--compact">
      <div class="card-header">
        <div class="card-header-content">
          <div class="card-title-group">
            <div class="card-icon-badge">
              <i class="pi pi-shield"></i>
            </div>
            <div>
              <h5 class="panel-title">Autenticidade de Documentos Fiscais</h5>
              <p class="panel-subtitle">Valide a autenticidade de NFS-e, DAPS ou Nota Avulsa</p>
            </div>
          </div>
        </div>
      </div>
      <div id="topo" class="card-body">
        <div class="form-title-links">
          <span class="form-title"
            >Informe os dados abaixo para autenticar a Nota Fiscal /
            {{ notaTomador ? 'Nota Tomador' : 'DAPS' }} / Nota Fiscal Avulsa.</span
          >
        </div>

        <!-- Tipo de Validação (Pills de seleção rápida) -->
        <div class="form-group-modern">
          <label class="form-label-section">Tipo de Documento:</label>
          <div class="radio-pill-group">
            <label class="radio-pill-item" :class="{ active: tipoValidacao === 'N' }">
              <RadioButton
                inputId="radio1"
                name="documento"
                value="N"
                v-model="tipoValidacao"
                tabindex="1"
              />
              <span>NFS-e / Avulsa</span>
            </label>
            <label class="radio-pill-item" :class="{ active: tipoValidacao === 'D' }">
              <RadioButton
                inputId="radio2"
                name="chave"
                value="D"
                v-model="tipoValidacao"
                tabindex="2"
              />
              <span>{{ notaTomador ? 'Nota Tomador' : 'DAPS' }}</span>
            </label>
          </div>
        </div>

        <!-- Linha: Tipo de Pessoa (reduzido) e CPF / CNPJ (mesma linha) -->
        <div class="d-flex align-items-start" style="gap: 12px; margin-bottom: 20px; width: 100%;">
          <div style="width: 140px; min-width: 140px; max-width: 140px; flex: 0 0 140px;">
            <label for="tipoPessoa" class="form-label-modern">Tipo de Pessoa: *</label>
            <Dropdown
              id="tipoPessoa"
              v-model="selectedTipoPessoa"
              :options="tiposPessoa"
              optionLabel="name"
              placeholder="Selecione"
              class="dropdown-modern"
              style="width: 100% !important;"
            />
          </div>

          <div style="flex: 1 1 auto; min-width: 0;">
            <label for="cpfCnpj" class="form-label-modern">
              {{ selectedTipoPessoa && selectedTipoPessoa.key === 'F' ? 'CPF do prestador: *' : 'CNPJ do prestador: *' }}
            </label>
            <template v-if="selectedTipoPessoa && selectedTipoPessoa.key === 'F'">
              <InputMask
                id="cpfCnpj"
                type="text"
                placeholder="000.000.000-00"
                autocomplete="off"
                v-model="documentoPrestador"
                mask="999.999.999-99"
                key="F"
                @blur="validarDocumento()"
                tabindex="3"
                class="input-modern"
                style="width: 100% !important;"
              />
            </template>
            <template v-else>
              <InputMask
                id="cpfCnpj"
                type="text"
                placeholder="00.000.000/0000-00"
                autocomplete="off"
                v-model="documentoPrestador"
                mask="**.***.***/****-99"
                key="J"
                @blur="validarDocumento()"
                tabindex="3"
                class="input-modern"
                style="text-transform: uppercase; width: 100% !important;"
              />
            </template>
          </div>
        </div>

        <!-- Chave de Validação -->
        <div class="form-group-modern">
          <label for="chave" class="form-label-modern">Chave de Validação:</label>
          <InputText
            id="chave"
            type="text"
            placeholder="Digite a chave de validação"
            autocomplete="off"
            tabindex="4"
            class="input-modern"
            v-model="chaveValidacao"
            :disabled="disabledChaveValidacao"
            @input="campoInputHandler('chaveValidacao')"
          />
          <small class="form-hint" v-if="disabledChaveValidacao">
            Campo desabilitado porque o número do documento foi informado
          </small>
        </div>

        <!-- Número da Nota -->
        <div class="form-group-modern">
          <label for="numero" class="form-label-modern">Número do Documento:</label>
          <InputText
            id="numero"
            type="text"
            placeholder="Digite o número"
            autocomplete="off"
            tabindex="5"
            class="input-modern"
            v-model="numeroNota"
            :disabled="disabledNumeroNota"
            @input="campoInputHandler('numeroNota')"
          />
          <small class="form-hint" v-if="disabledNumeroNota">
            Campo desabilitado porque a chave de validação foi informada
          </small>
        </div>

        <!-- Botões de Ação -->
        <div class="form-actions-modern" v-if="!sistemaBloqueado">
          <Button
            label="Voltar ao Login"
            type="button"
            class="btn-modern-secondary"
            id="btnVoltar"
            @click="login()"
            icon="pi pi-arrow-left"
            :disabled="loading"
          />
          <Button
            label="Autenticar Documento"
            type="submit"
            class="btn-modern-primary"
            id="btnAutenticar"
            @click="autenticar()"
            icon="pi pi-check"
            :disabled="loading"
          />
        </div>
      </div>
    </div>
    <Dialog class="test-box" header="Documento válido!" :visible.sync="showDialog" :modal="true" :closable="false">
      <div class="container">
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Deseja visualizar o documento validado?</label>
          </div>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row justify-content-between">
          <div>
            <Button
              @click="visualizarDanfse()"
              v-if="this.notaSelecionada && (this.notaSelecionada.transmitidoNacional === 'I' || this.notaSelecionada.transmitidoNacional === 'M')"
              href="#topo"
              type="button"
              label="DANFSE"
              class="p-button-primary mr-2 p-button-primary"
              icon="pi pi-print"
              :disabled="loading"
            />
            <Button
              @click="visualizar()"
              v-if="this.notaSelecionada && this.notaSelecionada.transmitidoNacional !== 'I' && this.notaSelecionada.transmitidoNacional !== 'M'"
              href="#topo"
              type="button"
              label="Visualizar"
              class="p-button-primary mr-2 p-button-primary"
              icon="pi pi-print"
              :disabled="loading"
            />
          </div>

          <div>
            <Button
              v-if="exibirBtnTermo"
              @click="visualisarTermoAutentic()"
              href="#topo"
              type="button"
              label="Termo Autenticação"
              class="p-button-primary mr-2 p-button-primary"
              icon="pi pi-print"
              :disabled="loading"
            />
          </div>

          <div>
            <Button
              v-if="exibirBtnXml"
              label="Exportar XML"
              type="submit"
              class="p-button-primary mr-2"
              icon="pi pi-download"
              @click="autenticarXml()"
              :disabled="loading"
            />
          </div>

          <div class="col-auto">
            <Button
              @click="showDialog = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import AutenticacaoService from '../services/nfse/autenticacao.service';
import DnsClienteService from '../services/nfse/dns.cliente.service';
import ReportService from '../services/report.service';
import Util from '../Utils/util';

export default {
  data() {
    return {
      documentoPrestador: null,
      chaveValidacao: null,
      numeroNota: null,
      tipoValidacao: 'N',
      loading: false,
      showDialog: false,
      documentoId: null,
      idCliente: null,
      anoAtual: null,
      notaTomador: false,
      selectedTipoPessoa: null,
      tiposPessoa: [
        { name: 'Física', key: 'F' },
        { name: 'Jurídica', key: 'J' },
        { name: 'Entidade', key: 'E' },
      ],
      disabledNumeroNota: false,
      disabledChaveValidacao: false,
      exibirBtnXml: false,
      exibirBtnTermo: false,
      notaSelecionada: null,
      sistemaBloqueado: false
    };
  },

  mounted() {
    this.$nextTick(() => {
      const cpfCnpjInput = document.getElementById('cpfCnpj');
      if (cpfCnpjInput) {
        cpfCnpjInput.focus();
      }
    });

    var d = new Date();
    this.anoAtual = d.getFullYear();

    if (!this.idCliente) {
      this.processando(true);
    }
    let host = window.location.hostname;
    DnsClienteService.get(host)
      .then((dns) => {
        if (dns && dns.data && dns.data.idCliente) {
          this.idCliente = dns.data.idCliente;
          if (dns.data.idBolBloquearSistema && dns.data.idBolBloquearSistema === 'S') {
            this.sistemaBloqueado = true;
          }
          if ('19533831040781681800D2584C905F8A' === this.idCliente) {
            this.notaTomador = true;
          }
        }
      })
      .finally(() => {
        this.processando(false);
      });
  },

  created() {
    try {
      const raw = localStorage.getItem('nfse_login_cache') || sessionStorage.getItem('nfse_login_cache');
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached) {
          this.idCliente = cached.idCliente || null;
          this.sistemaBloqueado = !!cached.sistemaBloqueado;
          this.notaTomador = !!cached.notaTomador;
        }
      }
    } catch (e) {
      console.warn(e);
    }

    this.selectedTipoPessoa = this.tiposPessoa[0];
    this.limparDados();
    this.documentoPrestador = this.$route.query.cpfCnpj;
    this.chaveValidacao = this.$route.query.chave;
    this.numeroNota = this.$route.query.numero;

    if (this.documentoPrestador) {
      let numeros = this.documentoPrestador.match(/\d+/g);
      numeros = numeros ? numeros.join('') : '';
      if (numeros.length > 11) {
        this.selectedTipoPessoa = this.tiposPessoa[1];
      } else {
        this.selectedTipoPessoa = this.tiposPessoa[0];
      }
    }
    this.tipoValidacao = this.$route.query.tipo ? this.$route.query.tipo : 'N';
  },

  computed: {
    exibirBotao() {
      return {
        voltar: true,
        avancar: true,
        credenciar: false,
      };
    },
  },

  methods: {
    campoInputHandler(campo) {
      switch (campo) {
        case 'chaveValidacao':
          if (this.chaveValidacao === '') {
            this.disabledNumeroNota = false;
          } else if (this.chaveValidacao !== '') {
            this.disabledNumeroNota = true;
          }
          break;
        case 'numeroNota':
          if (this.numeroNota === '') {
            this.disabledChaveValidacao = false;
          } else if (this.numeroNota !== '') {
            this.disabledChaveValidacao = true;
          }
          break;

        default:
          break;
      }
    },

    limparDados() {
      this.documentoPrestador = null;
      this.chaveValidacao = null;
      this.numeroNota = null;
      this.loading = false;
      this.showDialog = false;
      this.documentoId = '';
    },

    exibirDialog() {
      this.showDialog = true;
    },

    login() {
      this.$router.push('/login');
    },

    autenticar() {
      this.processando(true);
      console.log(this.numeroNota);

      if (this.documentoPrestador && this.tipoValidacao && this.idCliente && (this.chaveValidacao || this.numeroNota)) {
        AutenticacaoService.autenticacao(
          this.idCliente,
          this.tipoValidacao,
          this.documentoPrestador,
          this.chaveValidacao != null ? this.chaveValidacao.trim() : null,
          this.numeroNota != null ? this.numeroNota.trim() : null,
        )
          .then(
            (response) => {
              this.documentoId = response.data.id;
              console.log(response);
              console.log(this.tipoValidacao);

              this.notaSelecionada = response.data;

              if (this.tipoValidacao === 'N') {
                this.exibirBtnXml = true;
                this.exibirBtnTermo = true;
              } else {
                this.exibirBtnXml = false;
                this.exibirBtnTermo = false;
              }
              this.exibirDialog();
              this.$root.$emit('alert:success', 'Documento validado com sucesso!');
            },
            (error) => {
              this.$root.$emit('alert:error', error.response.data);
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', 'É necessário preencher todos os campos!');
        this.processando(false);
      }
    },

    autenticarXml() {
      this.processando(true);
      AutenticacaoService.autenticacaoXml(
        this.idCliente,
        this.tipoValidacao,
        this.documentoPrestador,
        this.chaveValidacao != null ? this.chaveValidacao.trim() : null,
        this.numeroNota != null ? this.numeroNota.trim() : null,
      )
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao efetuar o download!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    visualizarDanfse() {
      this.processando(true);

      AutenticacaoService.downloadDanfseHtml(this.notaSelecionada.id)
        .then((response) => {
          const html = response.data;
          ReportService.openHtmlFromBytes(html);
        })
        .catch((error) => {
          this.$root.$emit('alert:warn', 'Erro ao efetuar o download da DANFSE!');
          console.error('Erro ao efetuar o download da DANFSE:', error);
        })
        .then(() => {
          this.processando(false);
        });
    },

    visualizar() {
      this.processando(true);
      console.log(this.numeroNota);
      if (this.documentoPrestador && this.idCliente && (this.chaveValidacao || this.numeroNota)) {
        console.log('aqui');
        AutenticacaoService.visualisar(
          this.idCliente,
          this.tipoValidacao,
          this.documentoPrestador,
          this.chaveValidacao ? this.chaveValidacao : null,
          this.numeroNota ? this.numeroNota : null,
        )
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    visualisarTermoAutentic() {
      this.processando(true);
      console.log(this.documentoId);
      AutenticacaoService.visualisarTermoAutentic(this.documentoId)
        .then(
          () => {},
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documentoPrestador);

      if (!validar && this.documentoPrestador) {
        console.log(validar);
        this.$root.$emit('alert:error', 'CPF/CNPJ inválido!');
      }
    },
  },
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>
